/** @license React v16.5.1
 * schedule.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var d = !("undefined" === typeof window || !window.document || !window.document.createElement),
  f = Date,
  g = "function" === typeof setTimeout ? setTimeout : void 0,
  h = "function" === typeof clearTimeout ? clearTimeout : void 0,
  l = "function" === typeof requestAnimationFrame ? requestAnimationFrame : void 0,
  m = "function" === typeof cancelAnimationFrame ? cancelAnimationFrame : void 0,
  n = "object" === typeof performance && "function" === typeof performance.now;
exports.unstable_now = void 0;
if (n) {
  var p = performance;
  exports.unstable_now = function () {
    return p.now();
  };
} else exports.unstable_now = function () {
  return f.now();
};
exports.unstable_scheduleWork = void 0;
exports.unstable_cancelScheduledWork = void 0;
if (d) {
  var q = null,
    r = null,
    t = -1,
    u = !1,
    v = !1,
    w = void 0,
    x = void 0,
    y = function y(a) {
      w = l(function (b) {
        h(x);
        a(b);
      });
      x = g(function () {
        m(w);
        a(exports.unstable_now());
      }, 100);
    },
    z = 0,
    A = 33,
    B = 33,
    C = {
      didTimeout: !1,
      timeRemaining: function timeRemaining() {
        var a = z - exports.unstable_now();
        return 0 < a ? a : 0;
      }
    },
    E = function E(a, b) {
      var c = a.scheduledCallback,
        e = !1;
      try {
        c(b), e = !0;
      } finally {
        exports.unstable_cancelScheduledWork(a), e || (u = !0, window.postMessage(D, "*"));
      }
    },
    D = "__reactIdleCallback$" + Math.random().toString(36).slice(2);
  window.addEventListener("message", function (a) {
    if (a.source === window && a.data === D && (u = !1, null !== q)) {
      if (null !== q) {
        var b = exports.unstable_now();
        if (!(-1 === t || t > b)) {
          a = -1;
          for (var c = [], e = q; null !== e;) {
            var k = e.timeoutTime;
            -1 !== k && k <= b ? c.push(e) : -1 !== k && (-1 === a || k < a) && (a = k);
            e = e.next;
          }
          if (0 < c.length) for (C.didTimeout = !0, b = 0, e = c.length; b < e; b++) E(c[b], C);
          t = a;
        }
      }
      for (a = exports.unstable_now(); 0 < z - a && null !== q;) a = q, C.didTimeout = !1, E(a, C), a = exports.unstable_now();
      null === q || v || (v = !0, y(F));
    }
  }, !1);
  var F = function F(a) {
    v = !1;
    var b = a - z + B;
    b < B && A < B ? (8 > b && (b = 8), B = b < A ? A : b) : A = b;
    z = a + B;
    u || (u = !0, window.postMessage(D, "*"));
  };
  exports.unstable_scheduleWork = function (a, b) {
    var c = -1;
    null != b && "number" === typeof b.timeout && (c = exports.unstable_now() + b.timeout);
    if (-1 === t || -1 !== c && c < t) t = c;
    a = {
      scheduledCallback: a,
      timeoutTime: c,
      prev: null,
      next: null
    };
    null === q ? q = a : (b = a.prev = r, null !== b && (b.next = a));
    r = a;
    v || (v = !0, y(F));
    return a;
  };
  exports.unstable_cancelScheduledWork = function (a) {
    if (null !== a.prev || q === a) {
      var b = a.next,
        c = a.prev;
      a.next = null;
      a.prev = null;
      null !== b ? null !== c ? (c.next = b, b.prev = c) : (b.prev = null, q = b) : null !== c ? (c.next = null, r = c) : r = q = null;
    }
  };
} else {
  var G = new Map();
  exports.unstable_scheduleWork = function (a) {
    var b = {
        scheduledCallback: a,
        timeoutTime: 0,
        next: null,
        prev: null
      },
      c = g(function () {
        a({
          timeRemaining: function timeRemaining() {
            return Infinity;
          },
          didTimeout: !1
        });
      });
    G.set(a, c);
    return b;
  };
  exports.unstable_cancelScheduledWork = function (a) {
    var b = G.get(a.scheduledCallback);
    G.delete(a);
    h(b);
  };
}
;